document.addEventListener( 'DOMContentLoaded', () => {
  let closeButtons = document.querySelectorAll( '.b3rg-notification .b3rg-notification__close' );
  
  closeButtons.forEach( ( closeButton ) => {
    closeButton.addEventListener( 'click', ( event ) => {
      void handleNotificationClose( event );
    } );
  } );
  
  // Check for existing notifications on page load and hide them if they're already "closed"
  void checkExistingNotifications().catch( ( error ) => {
    console.error( 'Error checking existing notifications:', error );
  } );
} );

/**
 * Handle notification close event
 */
async function handleNotificationClose( event ) {
  // Disable the close button to prevent multiple clicks
  event.target.disabled = true;
  
  const notificationId = event.target.getAttribute( 'data-notification-id' );
  const notificationElement = event.target.closest( '.b3rg-notification' );
  
  // Get expiration time from data attribute (falls back to 24 hours if not set)
  const expirationTimeHours = parseInt( event.target.getAttribute( 'data-expiration-time' ) ) || 24;
  
  // Get notification text for hashing (similar to PHP logic)
  const notificationTextElement = notificationElement.querySelector( '.notification-text' );
  const notificationText = notificationTextElement ? notificationTextElement.textContent : '';
  
  try {
    // Create a hash of the notification text (similar to PHP sha256)
    const notificationHash = await b3rgHashString( notificationText );
    
    // Store the notification state in localStorage
    // Use the same naming convention as PHP: b3rg_notification_ + hex encoded ID
    const storageKey = 'b3rg_notification_' + b3rgStringToHex( notificationId );
    const storageValue = notificationHash;
    
    // Set expiration time based on the data attribute (same as PHP logic)
    const expirationTime = expirationTimeHours * 60 * 60 * 1000; // Convert hours to milliseconds
    const expirationDate = new Date().getTime() + expirationTime;
    
    // Store both the hash and expiration time
    const storageData = {
      hash: storageValue,
      expires: expirationDate
    };
    
    localStorage.setItem( storageKey, JSON.stringify( storageData ) );
    
    // Remove the notification from DOM
    notificationElement.remove();
    
    console.log( 'Notification closed and stored in localStorage:', storageKey );
  } catch ( error ) {
    console.error( 'Error processing notification:', error );
    // Re-enable the close button if processing fails
    event.target.disabled = false;
  }
}

/**
 * Check for existing notifications that should be hidden based on localStorage
 */
async function checkExistingNotifications() {
  const notifications = document.querySelectorAll( '.b3rg-notification' );
  
  for ( const notification of notifications ) {
    await processNotification( notification );
  }
}

/**
 * Process a single notification to check if it should be hidden
 */
async function processNotification( notification ) {
  const closeButton = notification.querySelector( '.b3rg-notification__close' );
  if ( !closeButton ) return;
  
  const notificationId = closeButton.getAttribute( 'data-notification-id' );
  const storageKey = 'b3rg_notification_' + b3rgStringToHex( notificationId );
  
  try {
    const storedData = localStorage.getItem( storageKey );
    if ( !storedData ) return;
    
    await handleStoredNotification( notification, storedData, storageKey );
  } catch ( error ) {
    console.error( 'Error checking notification state:', error );
  }
}

/**
 * Handle a notification that has stored data
 */
async function handleStoredNotification( notification, storedData, storageKey ) {
  const data = JSON.parse( storedData );
  const currentTime = new Date().getTime();
  
  // Check if the stored data has expired
  if ( !isNotificationExpired( data, currentTime ) ) {
    await handleValidNotification( notification, data, storageKey );
  } else {
    // Notification has expired, remove from storage and show
    localStorage.removeItem( storageKey );
    console.log( 'Notification expired, showing:', storageKey );
  }
}

/**
 * Check if notification has expired
 */
function isNotificationExpired( data, currentTime ) {
  return !data.expires || data.expires <= currentTime;
}

/**
 * Handle a notification that is still valid
 */
async function handleValidNotification( notification, data, storageKey ) {
  const notificationTextElement = notification.querySelector( '.notification-text' );
  const currentText = notificationTextElement ? notificationTextElement.textContent : '';
  const currentHash = await b3rgHashString( currentText );
  
  if ( data.hash === currentHash ) {
    // Content hasn't changed, hide the notification
    notification.remove();
    console.log( 'Hiding existing notification:', storageKey );
  } else {
    // Content has changed, remove old storage and show new notification
    localStorage.removeItem( storageKey );
    console.log( 'Content changed, showing new notification:', storageKey );
  }
}

/**
 * Create SHA-256 hash using Web Crypto API (similar to PHP's sha256)
 * Falls back to simple hash if Web Crypto is not available
 */
async function b3rgHashString( str ) {
  // Check if Web Crypto API is available
  if ( window.crypto?.subtle ) {
    try {
      const encoder = new TextEncoder();
      const data = encoder.encode( str );
      const hashBuffer = await window.crypto.subtle.digest( 'SHA-256', data );
      const hashArray = Array.from( new Uint8Array( hashBuffer ) );
      const hashHex = hashArray.map( b => b.toString( 16 ).padStart( 2, '0' ) ).join( '' );
      return hashHex;
    } catch ( error ) {
      console.warn( 'Web Crypto API failed, falling back to simple hash:', error );
    }
  }
  
  // Fallback to simple hash function
  let hash = 0;
  if ( str.length === 0 ) return hash.toString();
  
  for ( let i = 0; i < str.length; i++ ) {
    const char = str.charCodeAt( i );
    hash = ( ( hash << 5 ) - hash ) + char;
    hash = hash & hash; // Convert to 32-bit integer
  }
  
  return Math.abs( hash ).toString( 16 );
}

/**
 * Convert string to hex (simplified version of PHP's bin2hex)
 */
function b3rgStringToHex( str ) {
  let hex = '';
  for ( let i = 0; i < str.length; i++ ) {
    hex += str.charCodeAt( i ).toString( 16 ).padStart( 2, '0' );
  }
  return hex;
}
